import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const JOB_POSTS_LIST_ITEMS_PER_PAGE = 10;

export const useGetJobPostsList = () => {
  const { data, isLoading, error, send } = useRequest({
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
  });

  const getJobPostsList = (
    query: string,
    page: number = 1,
    limit: number = JOB_POSTS_LIST_ITEMS_PER_PAGE
  ) => {
    const reqUrl = query
      ? `/api/v1/jobPosts/search?limit=${limit}&page=${page}&${query}`
      : `/api/v1/jobPosts/search?limit=${limit}&page=${page}`;
    send({}, reqUrl).then();
  };

  return {
    getJobPostsList,
    data,
    isLoading,
    error,
  };
};
